'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002410 from "./presto.-Login-Page-View$$anon$10.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002418 from "./presto.-Login-Page-View$$anon$18.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002420 from "./presto.-Login-Page-View$$anon$20.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00248 from "./presto.-Login-Page-View$$anon$8.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$7() {
  this.b7l = null;
  this.b7d = null;
  this.b7e = false;
  this.b7m = null;
  this.b7n = false;
  this.b7q = null;
  this.b7j = null;
  this.b7k = false;
  this.b7f = null;
  this.b7g = false;
  this.b7h = null;
  this.b7i = false;
  this.b7o = false;
  this.b7p = false;
  this.b7l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b7q = "SingleAppUser";
}
export { $c_Lpresto_LoginPageView$$anon$7 as $c_Lpresto_LoginPageView$$anon$7 };
$p = $c_Lpresto_LoginPageView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$7;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$7() {
}
export { $h_Lpresto_LoginPageView$$anon$7 as $h_Lpresto_LoginPageView$$anon$7 };
$h_Lpresto_LoginPageView$$anon$7.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.b7l;
});
$p.L = (function() {
  if ((!this.b7e)) {
    this.b7d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b7e = true;
  }
  return this.b7d;
});
$p.O = (function() {
  if ((!this.b7n)) {
    this.b7m = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b7n = true;
  }
  return this.b7m;
});
$p.E = (function() {
  return this.b7q;
});
$p.t = (function() {
  if ((!this.b7k)) {
    this.b7j = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b7k = true;
  }
  return this.b7j;
});
$p.M = (function() {
  if ((!this.b7g)) {
    this.b7f = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00248.$c_Lpresto_LoginPageView$$anon$8(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002410.$c_Lpresto_LoginPageView$$anon$10(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002418.$c_Lpresto_LoginPageView$$anon$18())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.b7g = true;
  }
  return this.b7f;
});
$p.Q = (function() {
  if ((!this.b7i)) {
    this.b7h = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002420.$c_Lpresto_LoginPageView$$anon$20();
    this.b7i = true;
  }
  return this.b7h;
});
$p.w = (function() {
  if ((!this.b7p)) {
    this.b7o = false;
    this.b7p = true;
  }
  return this.b7o;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee130) => ((p) => \u03b4scrutinee130.adf(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_LoginPageView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$7, "presto.LoginPageView$$anon$7", ({
  Ml: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$7 as $d_Lpresto_LoginPageView$$anon$7 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$7.js.map
